import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { ILog, defaultValue } from 'app/shared/model/log.model';

export const ACTION_TYPES = {
  FETCH_LOG_LIST: 'log/FETCH_LOG_LIST',
  FETCH_LOG: 'log/FETCH_LOG'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ILog>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
  };

export type LogState = Readonly<typeof initialState>;

// Reducer

export default (state: LogState = initialState, action): LogState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_LOG_LIST):
    case REQUEST(ACTION_TYPES.FETCH_LOG):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case FAILURE(ACTION_TYPES.FETCH_LOG_LIST):
    case FAILURE(ACTION_TYPES.FETCH_LOG):
    case SUCCESS(ACTION_TYPES.FETCH_LOG_LIST):
      return {
        ...state,
        loading: false,
        totalItems: action.payload.headers['x-total-count'],
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_LOG):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    default:
      return state;
  }
};

const apiUrl = 'api/logs';

// Actions

export const getEntities: ICrudGetAllAction<ILog> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_LOG_LIST,
    payload: axios.get<ILog>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`)
  };
};

export const getLogs: ICrudGetAllAction<ILog> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_LOG_LIST,
    payload: axios.get<ILog>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`)
  };
};

export const getEntity: ICrudGetAction<ILog> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_LOG,
    payload: axios.get<ILog>(requestUrl)
  };
};
